import React, { useEffect, useRef, useState } from 'react';
import { GoogleMap, useJsApiLoader, Marker, InfoWindow } from '@react-google-maps/api';
import { Container, Typography, Card, CardContent, createTheme, ThemeProvider, Button, Box, IconButton, MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import { Redirect } from 'react-router-dom';



import PndRestApi from 'src/utils/pnd/PndRestApi';
import styled, { keyframes } from 'styled-components';
import Car from './assets/car.png';
import HeavyTruck from './assets/heavy_truck-01.png';
import LightTruck from './assets/light_truck.png';
import Bicycle from './assets/bicycle-01.png';
import MotorCyle from './assets/motorcyle.png'
import Van from './assets/van.png';
import RiderBlack from './assets/rider_black.png';
import RiderBlue from './assets/rider_blue.png';
import RiderGreen from './assets/rider_green.png';
import RiderRed from './assets/rider_red.png';
import RiderYellow from './assets/rider_yellow.png';
import mapStyle from './mapStyle';
import { ALL_RIDER, ASSIGNED, BICYCLE, BLACK_COLOR, CAR, DELIVERED_BUSY, DELIVERED_FREED, GREEN_COLOR, HEAVY_TRUCK, LIGHT_TRUCK, MOTORCYCLE, ON_BREAK, RETURNED_FREED, RIDER_ASSIGNED, RIDER_BUSY, RIDER_DEPARTED, RIDER_FREED, RIDER_ON_BREAK, RIDER_PICKED_UP, RIDER_RETURN_FREED, RIDER_RETURNED, RIDER_UNAVAILABLE, RIDER_UNDELIVERED, UNAVAILABLE, VAN, API_KEY } from 'src/utils/pnd/PndConstants';
import CloseIcon from 'mdi-react/CloseIcon';
import RefreshIcon from 'mdi-react/RefreshIcon'

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const scaleIn = keyframes`
  from {
    transform: scale(0.8);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
`;

const AnimatedCard = styled(Card)`
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  width: 300px;
  padding: 10px;
  z-index: 1;
  animation: ${fadeIn} 0.5s ease-in-out, ${scaleIn} 0.5s ease-in-out;
`;

const RiderLiveMap = () => {

    const theme = createTheme({
        typography: {
            fontFamily: 'ProductSansLight, sans-serif',
            h1: { fontFamily: 'ProductSansBold, sans-serif' },
            h2: { fontFamily: 'ProductSansBold, sans-serif' },
            h3: { fontFamily: 'ProductSansBold, sans-serif' },
            h4: { fontFamily: 'ProductSansBold, sans-serif' },
            h5: { fontFamily: 'ProductSansBold, sans-serif', fontSize: 30 },
            h6: { fontFamily: 'ProductSansRegular, sans-serif', fontSize: 18 },
            subtitle1: { fontFamily: 'ProductSansLight, sans-serif', fontSize: 15 },
            body1: { fontFamily: 'ProductSansLight, sans-serif', fontSize: 25 }
        }
    });

    const mapRef = useRef(null);

    const [selectedRider, setSelectedRider] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(0);
    const [filteredRiders, setFilteredRiders] = useState([]);
    const [isRedirect, setIsRedirect] = useState(false);



    const [allRiders, setAllRiders] = useState([]);





    const containerStyle = {
        height: '85vh',
        width: '80vw',
        maxWidth: '100%',
        maxHeight: '100%',
        borderRadius: '20px',
        borderColor: "#fff"
    };

    const center = {
        lat: 25.276987,
        lng: 55.296249
    };

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: API_KEY
    });



    const getMarkerIcon = (status, angle) => {
        let iconUrl;
        switch (status) {
            case BICYCLE:
                iconUrl = Bicycle;
                break;
            case MOTORCYCLE:
                iconUrl = MotorCyle;
                break;
            case LIGHT_TRUCK:
                iconUrl = LightTruck;
                break;
            case HEAVY_TRUCK:
                iconUrl = HeavyTruck;
                break;
            case CAR:
                iconUrl = Car;
                break;
            case VAN:
                iconUrl = Van;
                break;
            default:
                iconUrl = MotorCyle;
                break;
        }

        return {
            url: iconUrl,
            scaledSize: new window.google.maps.Size(60, 110),
            anchor: new window.google.maps.Point(25, 25),
            rotation: -31
        };
    };

    const getRiderStatusColor = (status) => {
        switch (status) {
            case RIDER_ASSIGNED:
                return ASSIGNED;
            case RIDER_PICKED_UP:
            case RIDER_BUSY:
            case RIDER_RETURNED:
            case RIDER_UNDELIVERED:
            case RIDER_DEPARTED:
                return DELIVERED_BUSY;
            case RIDER_FREED:
                return DELIVERED_FREED;
            case RIDER_RETURN_FREED:
                return RETURNED_FREED;
            case RIDER_UNAVAILABLE:
                return UNAVAILABLE;
            default:
                return ASSIGNED;
        }
    };

    const getProfileIcon = (status) => {
        switch (status) {
            case RIDER_ASSIGNED:
                return RiderGreen
            case RIDER_PICKED_UP:
            case RIDER_BUSY:
            case RIDER_RETURNED:
            case RIDER_UNDELIVERED:
            case RIDER_DEPARTED:
                return RiderRed
            case RIDER_FREED:
                return RiderBlue
            case RIDER_RETURN_FREED:
                return RiderGreen
            case RIDER_UNAVAILABLE:
                return RiderBlack
            default:
                return RiderBlack
        }

    }

    const Divider = () => (
        <hr style={{ border: '0.5px dotted #0D1E1C', margin: '4px' }} />
    );

    const getRiderLocation = async () => {
        try {
            const response = await PndRestApi.GetRiderLiveLocation(ALL_RIDER, false);
            if (response.status === 200 && response.data && Array.isArray(response.data.data)) {
                const updatedRiders = response.data.data
                    .filter(rider => rider.latitude && rider.longitude) // Check for valid lat/lng
                    .map(rider => ({
                        id: rider.plateNo || Date.now(),
                        lat: parseFloat(rider.latitude),
                        lng: parseFloat(rider.longitude),
                        angle: rider.angle || 0,
                        status: rider.riderStatusId,
                        orderCount: rider.orderCount,
                        plateNo: rider.plateNo,
                        isRiderOnBreak: rider.isRiderOnBreak,
                        vehicleMode: rider.vehicleMode,
                        riderStatus: rider.riderStatus,
                        riderStatusId: rider.riderStatusId,
                        location: rider.location,
                        vehicleId: rider.vehicleTypeId,
                        name: rider.riderName
                    }))
                    .filter(rider => !isNaN(rider.lat) && !isNaN(rider.lng));


                setAllRiders(updatedRiders);
                setFilteredRiders(updatedRiders);

            } else {
                console.error('Invalid response or empty data:', response);
                setFilteredRiders([]); // Handle the case where the response is empty or invalid
            }
        } catch (error) {
            console.error('Error fetching rider location:', error);
            setFilteredRiders([]); // Clear the riders list on error
        }
    };


    useEffect(() => {
        if (selectedRider === null && selectedStatus === 0) {
            getRiderLocation();

            const intervalId = setInterval(() => {
                getRiderLocation();

            }, 60000);

            return () => {
                clearInterval(intervalId);
            };
        }
    }, [selectedRider, selectedStatus]);




    useEffect(() => {
        if (mapRef.current && isLoaded && filteredRiders && filteredRiders.length !== 0) {
            const bounds = new window.google.maps.LatLngBounds();

            filteredRiders.forEach(rider => {
                bounds.extend(new window.google.maps.LatLng(rider.lat, rider.lng));
            });

            mapRef.current.setZoom(8.9);
        }
    }, [isLoaded, filteredRiders]);

    const onMapLoad = (map) => {
        mapRef.current = map;
    };

    const handleMarkerClick = (rider) => {
        setSelectedRider(rider);
        if (mapRef.current) {
            const { lat, lng } = rider;
            mapRef.current.setCenter({ lat, lng });
            mapRef.current.setZoom(35);
        }
    };

    const fitMapToMarkers = () => {
        if (mapRef.current && filteredRiders.length) {
            const bounds = new window.google.maps.LatLngBounds();
            filteredRiders.forEach(rider => {
                bounds.extend(new window.google.maps.LatLng(rider.lat, rider.lng));
            });

            mapRef.current.fitBounds(bounds, { padding: 10 });

            mapRef.current.setZoom(10);
        }
    };

    const handleCloseRiderDetails = () => {
        setSelectedRider(null);
        fitMapToMarkers();
    };


    const handleStatusChange = async (event) => {

        setFilteredRiders([]);

        const status = event.target.value;

        //console.log(status,'status')

        setSelectedStatus(status);

        setSelectedRider(null)


        if (status == RIDER_ON_BREAK) {
            try {
                const response = await PndRestApi.GetRiderLiveLocation(ALL_RIDER, true);

                if (response.status === 200 && response.data) {
                    const updatedRiders = response.data.data
                        .filter(rider => rider.latitude && rider.longitude)
                        .map(rider => ({
                            id: rider.plateNo || Date.now(),
                            lat: parseFloat(rider.latitude),
                            lng: parseFloat(rider.longitude),
                            angle: rider.angle || 0,
                            status: rider.riderStatusId,
                            orderCount: rider.orderCount,
                            plateNo: rider.plateNo,
                            isRiderOnBreak: rider.isRiderOnBreak,
                            vehicleMode: rider.vehicleMode,
                            riderStatus: rider.riderStatus,
                            riderStatusId: rider.riderStatusId,
                            location: rider.location,
                            vehicleId: rider.vehicleTypeId,
                            name: rider.riderName
                        }))
                        .filter(rider => !isNaN(rider.lat) && !isNaN(rider.lng));


                    setFilteredRiders(updatedRiders);
                }
                else {
                    setFilteredRiders([]);
                }
            } catch (error) {
                console.error('Error fetching rider location:', error);
            }
        }
        else {
            try {
                const response = await PndRestApi.GetRiderLiveLocation(status, false);

                if (response.status === 200 && response.data) {
                    const updatedRiders = response.data.data
                        .filter(rider => rider.latitude && rider.longitude)
                        .map(rider => ({
                            id: rider.plateNo || Date.now(),
                            lat: parseFloat(rider.latitude),
                            lng: parseFloat(rider.longitude),
                            angle: rider.angle || 0,
                            status: rider.riderStatusId,
                            orderCount: rider.orderCount,
                            plateNo: rider.plateNo,
                            isRiderOnBreak: rider.isRiderOnBreak,
                            vehicleMode: rider.vehicleMode,
                            riderStatus: rider.riderStatus,
                            riderStatusId: rider.riderStatusId,
                            location: rider.location,
                            vehicleId: rider.vehicleTypeId,
                            name: rider.riderName
                        }))
                        .filter(rider => !isNaN(rider.lat) && !isNaN(rider.lng));


                    setFilteredRiders(updatedRiders);
                }
                else {
                    setFilteredRiders([]);
                }
            } catch (error) {
                console.error('Error fetching rider location:', error);
            }
        }


    };

    const refreshMap = () => {
        setSelectedStatus(0)
        setSelectedRider(null);
        getRiderLocation();
    };

    if (isRedirect) {
        return <Redirect to="/web_app/views/rider_view" />;
    }

    if (allRiders.length === 0) {
        return (
            <ThemeProvider theme={theme}>
                <Container
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "70vh", // Optional: for vertical centering on full height
                    }}
                >
                    <Typography variant='h3' align="center">
                        Currently, no riders are available or on duty.
                    </Typography>
                    <Typography variant='body1' align="center">
                        You can add new riders by asking your admin or check the status of your riders.
                    </Typography>
                </Container>
            </ThemeProvider>

        )
    }

    else {
        return (
            <ThemeProvider theme={theme}>
                <Container
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        height: '90vh',
                        width: '100vw',
                        padding: 2
                    }}
                >
                    {isLoaded ? (
                        <div style={{ position: 'relative', width: containerStyle.width, height: containerStyle.height }}>

                            <Box sx={{ position: 'absolute', top: 10, left: 200, zIndex: 100 }}>

                                <FormControl sx={{ minWidth: 200, backgroundColor: '#fff' }} size="small">

                                    <InputLabel>Rider Status</InputLabel>
                                    <Select
                                        value={selectedStatus}
                                        onChange={handleStatusChange}
                                        label="Status"
                                    >
                                        <MenuItem value={ALL_RIDER}>All</MenuItem>
                                        <MenuItem value={RIDER_ASSIGNED}>Assigned</MenuItem>
                                        <MenuItem value={RIDER_ON_BREAK}>On Break</MenuItem>
                                        <MenuItem value={RIDER_PICKED_UP}>Picked Up</MenuItem>
                                        <MenuItem value={RIDER_DEPARTED}>Departed</MenuItem>
                                        <MenuItem value={RIDER_FREED}>Delivered Freed</MenuItem>
                                        <MenuItem value={RIDER_BUSY}>Busy</MenuItem>
                                        <MenuItem value={RIDER_RETURNED}>Returned at the Hub</MenuItem>
                                        <MenuItem value={RIDER_UNDELIVERED}>Undelivered</MenuItem>
                                        <MenuItem value={RIDER_RETURN_FREED}>Return Freed at the Hub</MenuItem>
                                        <MenuItem value={RIDER_UNAVAILABLE}>Unavailable</MenuItem>
                                    </Select>
                                </FormControl>

                            </Box>

                            <Box sx={{ position: 'absolute', top: 10, right: 20, zIndex: 100 }}>

                                <Button
                                    onClick={() => setIsRedirect(true)}
                                    sx={{
                                        marginRight: 3,
                                        '&:hover': {
                                            backgroundColor: GREEN_COLOR, // Change on hover
                                        },

                                        backgroundColor: BLACK_COLOR
                                    }} variant='contained'>Rider Grid View</Button>


                                <IconButton
                                    onClick={() => { refreshMap() }}
                                    sx={{ border: '2px solid #414141', backgroundColor: '#fff' }}
                                >
                                    <RefreshIcon color='#0D1E1C' />
                                </IconButton>
                            </Box>

                            <GoogleMap
                                mapContainerStyle={containerStyle}
                                center={center}
                                zoom={11}
                                onLoad={onMapLoad}
                                options={{ styles: mapStyle, zoomControl: true }}
                            >
                                {filteredRiders.map(rider => (
                                    <Marker
                                        key={`marker-${rider.id}`}
                                        position={{ lat: rider.lat, lng: rider.lng }}
                                        icon={getMarkerIcon(rider.vehicleId, rider.angle)}
                                        title={rider.name}
                                        onClick={() => handleMarkerClick(rider)}
                                        animation={window.google.maps.Animation.DROP}
                                    />
                                ))}

                                {filteredRiders.map(rider => (
                                    <InfoWindow
                                        key={`info-${rider.id}`}
                                        position={{ lat: rider.lat, lng: rider.lng }}
                                        options={{ disableAutoPan: false, headerDisabled: true }}
                                    >
                                        <div style={{ textAlign: 'center' }}>
                                            <Typography sx={{ textAlign: "center" }} variant="subtitle1">{rider.name}</Typography>
                                            <img
                                                style={{
                                                    alignSelf: "center",
                                                    height: 50,
                                                    width: 50,
                                                    objectFit: 'contain'
                                                }}
                                                src={rider.isRiderOnBreak ? RiderYellow : getProfileIcon(rider.riderStatusId)}
                                                alt={`${rider.name} icon`}
                                            />
                                        </div>
                                    </InfoWindow>
                                ))}
                                {selectedRider && (
                                    <AnimatedCard variant='outlined'>
                                        <CardContent>
                                            <IconButton
                                                onClick={handleCloseRiderDetails}
                                                sx={{ border: '2px solid #ccc', position: 'absolute', top: 8, right: 8 }}
                                            >
                                                <CloseIcon />
                                            </IconButton>

                                            <Typography variant="h4">{selectedRider.name}</Typography>
                                            <Typography variant='h6'>Rider Status</Typography>

                                            <Card
                                                sx={{
                                                    mt: 1,
                                                    padding: 0.5,
                                                    backgroundColor: selectedRider?.isRiderOnBreak ? ON_BREAK : getRiderStatusColor(selectedRider.riderStatusId),
                                                    borderRadius: '20px',
                                                }}
                                                variant='outlined'
                                            >
                                                <Typography sx={{ textAlign: "center", color: "#fff" }} variant="h6">{selectedRider?.isRiderOnBreak ? "On Break" : selectedRider.riderStatus?.toUpperCase()}</Typography>
                                            </Card>



                                            <Box
                                                display="flex"
                                                alignItems="center"
                                                width="100%"
                                                justifyContent={"space-between"}
                                            >
                                                <Typography sx={{ marginTop: 1 }} variant='h6'>Vehicle Mode</Typography>
                                                <Typography sx={{ marginTop: 1 }} variant='subtitle1'>{selectedRider.vehicleMode}</Typography>
                                            </Box>

                                            <Divider />

                                            <Box
                                                display="flex"
                                                alignItems="center"
                                                width="100%"
                                                justifyContent={"space-between"}
                                            >
                                                <Typography sx={{ marginTop: 1 }} variant='h6'>Plate No.</Typography>
                                                <Typography sx={{ marginTop: 1 }} variant='subtitle1'>{selectedRider.plateNo}</Typography>
                                            </Box>

                                            <Divider />

                                            <Typography sx={{ marginTop: 1 }} variant='h6'>Current Location</Typography>
                                            <Typography variant="subtitle1">
                                                {selectedRider.location}
                                            </Typography>
                                        </CardContent>
                                    </AnimatedCard>
                                )}



                            </GoogleMap>
                        </div>
                    ) : (
                        <div>Loading...</div>
                    )}
                </Container>
            </ThemeProvider>
        );
    }
};

export default RiderLiveMap;
